'use strict';

var jsxRuntime = require('react/jsx-runtime');
var BackDropLiftContainer = require('../BackDropLiftContainer/BackDropLiftContainer.js');
var BottomModalContainer = require('../BottomModalContainer/BottomModalContainer.js');
var FullModalContainer = require('../FullModalContainer/FullModalContainer.js');
var ModalContainer = require('../ModalContainer/ModalContainer.js');
var Portal = require('../Portal/Portal.js');
require('../../../_virtual/_tslib.js');
require('tailwind-merge');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

/**
 * 모달 창을 표시하는 컴포넌트입니다.
 *
 * @component
 * @param {object} props - 모달 컴포넌트 속성
 * @param {boolean} props.isOpen - 모달의 표시 여부를 결정합니다
 * @param {string} [props.rootId] - 모달이 마운트될 DOM 요소의 ID입니다
 * @param {'default' | 'full' | 'bottom'} [props.variant='default'] - 모달의 형태를 지정합니다 (default, full, bottom)
 * @param {'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'} [props.size='md'] - 모달의 크기를 지정합니다 (xs, sm, md, lg, xl, full)
 * @param {'auto' | 'visible' | 'hidden' | 'scroll'} [props.overflow='auto'] - 모달 내용의 오버플로우 처리 방식을 지정합니다 (auto, visible, hidden, scroll)
 * @param {boolean} [props.isBackgroundBlack=true] - 배경색을 검정색으로 할지 여부를 결정합니다
 * @param {boolean} [props.isFixedHeight] - 바텀 시트 모달의 고정 높이 사용 여부를 결정합니다
 * @param {boolean} [props.isPreventScroll=true] - 모달 외부 스크롤 방지 여부를 결정합니다
 * @param {boolean} [props.needCleanup=true] - 모달이 닫힐 때 Portal 정리 여부를 결정합니다
 * @param {() => void} [props.onClose] - 모달이 닫힐 때 실행될 콜백 함수입니다
 * @param {React.ReactNode} props.children - 모달 내부에 표시될 컨텐츠입니다
 *
 * @example
 * // 기본 모달
 * <Modal isOpen={isOpen} onClose={handleClose}>
 *   <div>모달 내용</div>
 * </Modal>
 *
 * // 전체 화면 모달
 * <Modal isOpen={isOpen} variant="full" onClose={handleClose}>
 *   <div>전체 화면 모달 내용</div>
 * </Modal>
 *
 * // 바텀 시트 모달
 * <Modal isOpen={isOpen} variant="bottom" onClose={handleClose}>
 *   <div>바텀 시트 내용</div>
 * </Modal>
 */ const Modal = ({ isOpen, rootId, variant = 'default', size = 'md', overflow = 'auto', isBackgroundBlack = true, isFixedHeight, isPreventScroll = true, onClose, needCleanup = true, children })=>{
    const isBottomVariant = variant === 'bottom';
    const isFullVariant = variant === 'full';
    const isDefaultVariant = variant === 'default';
    const shouldCleanupPortal = needCleanup && !rootId;
    return jsxRuntime.jsx(Portal, {
        rootId: rootId,
        needCleanup: shouldCleanupPortal,
        children: jsxRuntime.jsxs(BackDropLiftContainer, {
            isOpen: isOpen,
            onClose: onClose,
            testId: "design-system--modal",
            isBackgroundBlack: isBackgroundBlack,
            isPreventScroll: isPreventScroll,
            isBottomSheet: isBottomVariant,
            children: [
                isDefaultVariant && jsxRuntime.jsx(Box, {
                    className: size === 'full' ? 'px-5' : '',
                    children: jsxRuntime.jsx(ModalContainer, {
                        size: size,
                        overflow: overflow,
                        children: children
                    })
                }),
                isFullVariant && jsxRuntime.jsx(FullModalContainer, {
                    children: children
                }),
                isBottomVariant && onClose && jsxRuntime.jsx(BottomModalContainer, {
                    onClose: onClose,
                    isFixedHeight: isFixedHeight,
                    children: children
                })
            ]
        })
    });
};

module.exports = Modal;
